import * as React from 'react';
export const arrowUpSvg = React.forwardRef(function arrowUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.381 6.381A.875.875 0 1 0 2.62 7.62l4.506-4.507V15a.875.875 0 1 0 1.75 0V3.112l4.506 4.507A.875.875 0 1 0 14.62 6.38l-6-6a.872.872 0 0 0-1.238 0l-6 6Z',
    }),
  );
});
arrowUpSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowUp = {
  category: 'icon',
  colorable: true,
  name: 'arrowUp',
  svg: arrowUpSvg,
};
